import * as React from 'react'
import { useMemo } from 'react'

import type { CustomFieldProps } from './typings'
import { AdditionalInfoListItem } from '@sales-center/components'
import type { CustomFieldDateValue } from '@sales-center/common'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

type CustomDateProps = CustomFieldProps & {
  value: CustomFieldDateValue
}

export function CustomDate(props: CustomDateProps) {
  const {
    customFields,
    value: { customFieldId, date },
  } = props

  const { formatDate } = useLocalizationDateFormat()

  const [thisField, subtitle] = useMemo(
    () => [customFields.find((x) => x.id === customFieldId), formatDate(date)],
    [customFieldId, customFields, date, formatDate],
  )

  if (!thisField) return null

  return <AdditionalInfoListItem title={thisField.name} subtitle={subtitle} />
}
